
(function() {
  var result = { translations: { "ar-eg": { "i18n": { "duration": { "seconds": "{{ seconds }} \u062B\u0627\u0646\u064A\u0629", "minutes": "{{ minutes }} \u062F\u0642\u064A\u0642\u0629", "hours": "{{ hours }} \u0633\u0627\u0639\u0629", "hoursAndMinutes": "{{ hours }} \u0633\u0627\u0639\u0629 {{ minutes }} \u062F\u0642\u064A\u0642\u0629", "days": "{{ days }} \u0623\u064A\u0627\u0645", "shortForm": { "seconds": "{{ seconds }} \u062B", "minutes": "{{ minutes }} \u062F", "hours": "{{ hours }} \u0633", "days": "{{ days }} \u064A", "hoursAndMinutes": "{{ hours }} \u0633 {{ minutes }} \u062F" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}\u060C \u062A\u0645\u062F\u064A\u062F {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ar-eg": "static-7.807"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.807",
    "ar-eg": "static-7.807",
    "bg": "static-7.807",
    "bn": "static-7.807",
    "ca-es": "static-7.807",
    "cs": "static-7.807",
    "da": "static-7.807",
    "de": "static-7.807",
    "el": "static-7.807",
    "en-gb": "static-7.807",
    "en": "static-7.807",
    "es-mx": "static-7.807",
    "es": "static-7.807",
    "fi": "static-7.807",
    "fr-ca": "static-7.807",
    "fr": "static-7.807",
    "he-il": "static-7.807",
    "hr": "static-7.807",
    "hu": "static-7.807",
    "id": "static-7.807",
    "it": "static-7.807",
    "ja": "static-7.807",
    "ko": "static-7.807",
    "lt": "static-7.807",
    "ms": "static-7.807",
    "nl": "static-7.807",
    "no": "static-7.807",
    "pl": "static-7.807",
    "pt-br": "static-7.807",
    "pt-pt": "static-7.807",
    "ro": "static-7.807",
    "ru": "static-7.807",
    "sk": "static-7.807",
    "sl": "static-7.807",
    "sv": "static-7.807",
    "th": "static-7.807",
    "tl": "static-7.807",
    "tr": "static-7.807",
    "uk": "static-7.807",
    "vi": "static-7.807",
    "x-pseudo": "static-7.807",
    "zh-cn": "static-7.807",
    "zh-hk": "static-7.807",
    "zh-tw": "static-7.807"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ar-eg', {version: 'static-7.807'}); }
})();


